import { render } from "./detail-drawer.vue?vue&type=template&id=5fb5359e&scoped=true&ts=true"
import script from "./detail-drawer.vue?vue&type=script&lang=ts"
export * from "./detail-drawer.vue?vue&type=script&lang=ts"

import "./detail-drawer.vue?vue&type=style&index=0&id=5fb5359e&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb5359e"]])

export default __exports__